"use client";
import { useGlobal } from "@/features/global/GlobalContext";
import { RichTextRender } from "@/components/ui/RichTextRender";
import { AlertCircleIcon } from "@/components/icons/AlertCircle";
import styles from "./AnnouncementBar.module.css";

export const AnnouncementBar = () => {
  const {
    data: { announcement, colorMap },
  } = useGlobal();

  if (!announcement.enabled || !announcement.text) {
    return null;
  }

  const colorEntry = announcement.backgroundColor
    ? colorMap[announcement.backgroundColor]
    : undefined;

  return (
    <section className={styles.wrapper} aria-label="Announcement">
      <div
        className={styles.bar}
        style={{
          backgroundColor: colorEntry?.color,
          color: colorEntry?.foreground,
        }}
      >
        <AlertCircleIcon className={styles.icon} aria-hidden="true" />
        <RichTextRender
          blok={announcement.text}
          preview={false}
          className={styles.text}
        />
      </div>
    </section>
  );
};
